import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  ScrollView,
  Alert,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import InputFree from "../../component/inputfree";
import Calendar from "react-calendar";
import moment from "moment";
import Modal from "modal-react-native-web";
import RNPickerSelect from "react-native-picker-select";
import { pickImage } from "../../action/authImage";
import { FontAwesome5 } from "@expo/vector-icons";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
import { useIsFocused } from "@react-navigation/native";
import { getevent } from "../../action/actionGet";

const { width, height } = Dimensions.get("window");

export default function CreateCoupon({ navigation, route }) {
  const token = useRecoilValue(tokenState);
  const [modalResult, setModalResult] = useState(false);
  const [locate, setLo] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const [locate1, setLo1] = useState({});
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [dateState1, setDateState1] = useState(new Date());
  const [masterEvents, setMasterEvents] = useState([]);
  const [masterPackages, setMasterPackages] = useState([]);
  const [dataReward, setDataReward] = useState([
    { coin: "" },
    { diamond: "" },
    {
      shirt: {},
    },
  ]);
  const isFocused = useIsFocused();
  const [body, setBody] = useState({
    eventId: "",
    packageId: "",
    isVip: false,
    quantity: 1,
  });

  const placeholder = {
    label: "สถานะ",
    value: null,
    color: "#777777",
  };

  const items = [
    { label: "VIP", value: "Active" },
    { label: "General", value: "NotActive" },
  ];

  const changeStartDate = (e) => {
    setDateState(e);
  };

  const changeExpireDate = (e) => {
    setDateState1(e);
  };

  function mapReward(rawRewards) {
    const rewards = JSON.parse(rawRewards);

    return rewards.map((reward) => {
      if (reward.shirt) {
        return {
          type: "ไอเทม",
          shirt: reward.shirt,
        };
      }
      if (reward.diamond != undefined) {
        return {
          type: "ไดมอนด์",
          diamond: !reward.diamond ? "0" : reward.diamond,
        };
      }

      return {
        type: "โกลด์",
        coin: reward.coin,
      };
    });
  }

  function mapValue(rawValues) {
    const values = JSON.parse(rawValues);
    return values.map((value) => {
      return {
        distance: value.distance,
        price: value.price,
        cost: value.cost,
        img_pre: value.img_pre,
        img_basic: value.img_basic,
      };
    });
  }

  async function getMasterEvents() {
    const results = await getevent(token);
    if (results.status == 200) {
      const events = results?.data?.data;
      setMasterEvents(
        events?.map((item) => {
          return {
            label: item.titel,
            value: (item?.id).toString(),
            detail: item,
          };
        }),
      );
    }
  }

  useEffect(() => {
    if (route?.params?.id) {
      setBody({
        ...route.params,
      });
    }

    getMasterEvents();
  }, [isFocused]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewFree}>
            <Text style={styles.textFree}>
              EVENT{" "}
              <Text style={styles.textFree1}>
                / <Text style={styles.textFree1}>Coupon </Text>
              </Text>
              <Text style={styles.textFree1}>
                / <Text style={styles.textFree1}>ADD</Text>
              </Text>
            </Text>
            <View style={styles.viewTouch}>
              <TouchableOpacity
                onPress={async () => {
                  try {
                    if (!body.eventId || !body.packageId) {
                      Alert.alert("แจ้งเตือน", "กรุณาเลือกอีเวนท์และแพ็คเกจก่อนบันทึก");
                      return;
                    }

                    const response = await apiservice({
                      path: "/admin/generate-coupons",
                      method: "post",
                      body: { ...body, isVip: body.isVip === 'Active' ? true : false },
                      token: token?.accessToken,
                    });

                    if (response.status == 200) {
                      navigation.navigate("HomeEventCoupon");
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}
                style={styles.touchAdd}
              >
                <Text style={styles.textAdd}>บันทึก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  navigation.navigate("HomeEvent");
                }}
                style={styles.touchAdd}
              >
                <Text style={styles.textAdd}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              width: width * 0.82,
              borderWidth: 0.05,
              borderColor: "#00000010",
              backgroundColor: "#fff",
              shadowColor: "#000",
              shadowOffset: {
                width: 0,
                height: 2,
              },
              shadowOpacity: 0.25,
              shadowRadius: 3.84,
              elevation: 5,
              marginTop: 10,
            }}
          >
            <View style={styles.view}>
              <View style={styles.viewin}>
                <View
                  style={[
                    styles.style,
                    { justifyContent: "space-between" },
                    { marginRight: 5 },
                  ]}
                >
                  <View style={{}}>
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      อีเวนท์
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => {
                        setBody((prev) => ({
                          ...prev,
                          eventId: text,
                          packageId: "",
                        }));
                        const event = masterEvents.filter(
                          (item) => item.value == text,
                        )[0];
                        setMasterPackages(
                          event?.detail?.distances?.map((item, index) => ({
                            label: item.title,
                            value: item.id?.toString(),
                          })) ?? [],
                        );
                      }}
                      style={{
                        inputWeb: {
                          width: width * 0.39,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.eventId || null}
                      items={masterEvents}
                    />
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      แพ็คเกจ
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => {
                        setBody((prev) => ({ ...prev, packageId: text || "" }));
                      }}
                      style={{
                        inputWeb: {
                          width: width * 0.39,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.packageId || null}
                      items={masterPackages}
                    />
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      VIP
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) =>
                        setBody({ ...body, isVip: text })
                      }
                      style={{
                        inputWeb: {
                          width: width * 0.39,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.isVip || null}
                      items={items}
                    />
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      จำนวนคูปอง
                    </Text>
                    <TextInput
                      style={styles.touchheigh}
                      onChangeText={(text) =>
                        setBody({ ...body, quantity: text })
                      }
                      value={body.quantity?.toString()}
                      keyboardType="numeric"
                    />
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
      {handelCalendar && (
        <View
          style={{
            width: width * 0.39,
            position: "absolute",
            top: height * 0.2,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState}
              onChange={changeStartDate}
              onChangeText={(text) => {
                setBody({ ...body, startDate: text });
              }}
              onClickDay={(e) => {
                setBody({ ...body, startDate: e });
                setTimeout(() => {
                  setHandelCalendar((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
      {handelCalendar1 && (
        <View
          style={{
            width: width * 0.39,
            position: "absolute",
            zIndex: 99,
            top: height * 0.26,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState1}
              onChange={changeExpireDate}
              onChangeText={(text) => {
                setBody({ ...body, endDate: text });
              }}
              onClickDay={(a) => {
                setBody({ ...body, endDate: a });
                setTimeout(() => {
                  setHandelCalendar1((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewFree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textFree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textFree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchAdd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textAdd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textAdd1: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
  },
  viewTouch: {
    flexDirection: "row",
    width: width * 0.35,
    justifyContent: "flex-end",
    gap: 10,
  },
  view: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewin: {
    width: width * 0.41,
    padding: 10,
    backgroundColor: "#ffffff",
  },
  koblogo: {
    width: width * 0.395,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  kob: {
    width: width * 0.395,
    height: 120,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  kob1: {
    width: width * 0.395,

    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  style: {
    flexDirection: "row",
    marginTop: 5,
  },
  viewimg: {
    width: 120,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  viewimg1: {
    width: 60,
    height: 100,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  viewimgbib: {
    width: 160,
    height: 90,
    justifyContent: "center",
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },

  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.19,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  touchheigh: {
    width: width * 0.395,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  input: {
    width: width * 0.25,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewinput: {
    flexDirection: "row",
    width: width * 0.36,
    justifyContent: "space-between",
  },
  textinput: {
    width: width * 0.395,
    height: 70,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewmain: {
    width: width * 0.395,
    height: 75,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingHorizontal: 10,
    borderRadius: 5,
    marginBottom: 10,
    marginTop: 10,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  mainin: {
    width: width * 0.39,
    alignSelf: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  botton: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
  },
  inputimni: {
    width: width * 0.12,
    height: 38,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  logo: {
    width: width * 0.245,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 10,
    marginBottom: 10,
    flexDirection: "row",
  },
  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  touchsmall: {
    backgroundColor: "#FCC81D",
    width: 60,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textsmall: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textmini: {
    fontSize: 9,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  backmodal: {
    width: width,
    height: height,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewinmodail: {
    width: width * 0.5,
    alignSelf: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    paddingVertical: 30,
  },
  imgko: {
    width: 25,
    height: 25,
    position: "absolute",
    alignSelf: "center",
  },
  line: {
    width: width * 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#44444440",
    marginTop: 10,
  },
  liner: {
    flexDirection: "row",
    width: width * 0.48,
    justifyContent: "space-between",
    height: 40,
    borderLeftWidth: 1,
    borderLeftColor: "#2DCE98",
    marginTop: 10,
    alignSelf: "center",
  },
  ok: {
    width: 40,
    height: 40,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  real: {
    width: width * 0.15,
    justifyContent: "space-between",
    alignSelf: "center",
    flexDirection: "row",
  },
  botton3: {
    alignSelf: "center",
    marginLeft: -25,
  },
});
